import {
  makeRequest,
  makeConcurrentRequest,
  formatDateParam,
} from "../lib/makeRequest";

export const daily_summary_overall = (data) => {
  const params = { covered_date: formatDateParam(data.covered_date) };
  return makeRequest("/daily-transactions/overall", params);
};

export const daily_summary_cluster = (data) => {
  const params = { covered_date: formatDateParam(data.covered_date) };
  return makeRequest(`/daily-transactions/cluster/${data.clusterId}`, params);
};

export const daily_summary_area = (data) => {
  const params = { covered_date: formatDateParam(data.covered_date) };
  return makeRequest(`/daily-transactions/area/${data.area_code}`, params);
};

export const daily_summary_branch = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("covered_date", formatDateParam(data.covered_date));
  return makeRequest(
    `/daily-transactions/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};

export const daily_summary_branch_concurrent_request = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("covered_date", formatDateParam(data.covered_date));

  const requestData = data.branchCodechunks.map((chunk) => {
    return {
      endpoint: `/daily-transactions/branches?${urlParams.toString()}`,
      params: chunk,
    };
  });

  return makeConcurrentRequest(requestData, "post");
};
